import React, { useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "./store";
import AuthContext from "../store/AuthContext";
import {
  fetchUserPreferences,
  clearUserPreferences,
} from "./states/userPreferences.state";

export function UserPreferencesSync({
  children,
}: React.PropsWithChildren) {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(clearUserPreferences());
    } else {
      dispatch(fetchUserPreferences());
    }
  }, [isAuthenticated, dispatch]);

  return <>{children}</>;
}
